import { useState } from "react";
import { ChevronDown, Info } from "lucide-react";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
import { MiniMarkdown } from "@/components/apps/MiniMarkdown";
import { useI18n } from "@/i18n/I18nContext";

export const AboutPanel = ({ about, testId = "about-panel" }) => {
  const { t, lang } = useI18n();
  const [open, setOpen] = useState(false);
  if (!about) return null;
  return (
    <Collapsible open={open} onOpenChange={setOpen} className="mt-4 rounded-xl border border-[rgba(245,197,66,0.2)] bg-black/30" data-testid={testId}>
      <CollapsibleTrigger
        className="flex w-full items-center justify-between gap-2 px-4 py-3 text-xs font-semibold uppercase tracking-wider text-[var(--gold)] transition-colors duration-200 hover:text-[var(--gold-bright)]"
        data-testid={`${testId}-toggle`}
      >
        <span className="inline-flex items-center gap-2"><Info className="h-4 w-4" /> {t("about.more")}</span>
        <ChevronDown className={`h-4 w-4 transition-transform duration-200 ${open ? "rotate-180" : ""}`} />
      </CollapsibleTrigger>
      <CollapsibleContent className="border-t border-[rgba(245,197,66,0.15)] px-4 py-4" data-testid={`${testId}-content`}>
        <MiniMarkdown text={about[lang] || about.fr} />
      </CollapsibleContent>
    </Collapsible>
  );
};
